import { render, staticRenderFns } from "./IconRight.vue?vue&type=template&id=64a4c36e&"
import script from "./IconRight.vue?vue&type=script&lang=js&"
export * from "./IconRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a4c36e')) {
      api.createRecord('64a4c36e', component.options)
    } else {
      api.reload('64a4c36e', component.options)
    }
    module.hot.accept("./IconRight.vue?vue&type=template&id=64a4c36e&", function () {
      api.rerender('64a4c36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconRight.vue"
export default component.exports